import { get_whitepaper } from "http/components/Requests";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { set_WhitepaperData } from "../../../Redux/slices/dataSlice";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { decodeText } from "Utils/Helpers/TextDecoder";
import { useEffect } from "react";

export default function WhitePaperDrawer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { whitepaper } = useSelector((state) => ({
    whitepaper: state.data.whitepaper,
  }));

  useEffect(() => {
    getWhitepaperData();
  }, []);

  const getWhitepaperData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_whitepaper();
    if (CheckApiStatus(response))
      dispatch(set_WhitepaperData(response.data.infos));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      {whitepaper &&
        whitepaper.map((item) => {
          return (
            <div className="each-wp" key={`whitePaper-${item.id}`}>
              <div className="wp-icon">
                <img src={item.icon} alt={item.title} />
                <strong className="set-Audiowide-font d-block d-md-none">
                  {t(item.title)}
                </strong>
              </div>
              <div className="wp-info">
                <strong className="set-Audiowide-font d-none d-md-block">
                  {t(item.title)}
                </strong>
                <div
                  dangerouslySetInnerHTML={{
                    __html: decodeText(t(item.description)),
                  }}
                />
              </div>
            </div>
          );
        })}
    </>
  );
}
